import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { replace } from 'connected-react-router';

import { clientLogger } from '@flow/logging/client-logger';

import ErrorScreenTemplate from '@app/components/agreement-loader/error-handler/error-screen-template';
import {
  redirectToMFA,
  agreementHasMFA,
} from '@app/components/agreement-loader/error-handler/error-helpers';
import LoadingScreen from '@app/components/agreement-loader/loading-screen';

type Props = {
  agreementId: Oneflow.Agreement['id'];
  error: any;
  guestToken: string;
};

const ErrorHandler = ({ agreementId, error, guestToken }: Props) => {
  const dispatch = useDispatch();
  const triggerErrors = useCallback(() => {
    if (agreementHasMFA(error, guestToken)) {
      const navigate = (url: string) => {
        dispatch(replace(url));
      };
      redirectToMFA(navigate, agreementId, guestToken);
    }
    clientLogger.error(error);
  }, [
    agreementId,
    error,
    guestToken,
    dispatch,
  ]);

  useEffect(() => {
    triggerErrors();
  }, [
    triggerErrors,
  ]);

  if (agreementHasMFA(error, guestToken)) {
    return <LoadingScreen />;
  }

  return <ErrorScreenTemplate error={error} />;
};

export default ErrorHandler;
